import React, {Component } from 'react';
import firebase from 'firebase/app'

export default class PictographsGasController extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      billData: null,
    }
  }

  componentDidMount() {
    let result = null;

    
    let year = new Date().getFullYear();
    let month = new Date().getMonth();
    
    var formattedNumber = ("0" + month).slice(-2) + '-' + year;


    
    
    let userKey = this.props.user.email.replace(/[^a-zA-Z0-9]/g, "");
    let billsRef = firebase.database().ref('userBills/' + userKey + '/gas');
    billsRef.on('value', getData)

    function getData(data) {
      if (data.exists() && data.val()[formattedNumber] != null) {
        var gasDryer = Math.round(parseInt(data.val()[formattedNumber].usage) * 99976.1 / 11000)
        const item = (<span>{gasDryer} gas dryer cycles</span>); 
        console.log(item);
        result = item
        console.log(result);
      } else {
        const item = (<span>You have no available gas bills for this month</span>);
        result = item
      }
    }

    this.setState({billData: result})
   
  }


  render() {
    return (
      <div className='pictograph-container column'>
        <div>
          <img className='pictograph-image' alt="cartoon dryer" src='/img/dryer.png'></img>
          {this.state.billData}</div>
      </div>   
    )
  }
}